var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image_saver_path" },
    [
      _c(
        "div",
        { staticClass: "box", on: { click: _vm.transferAimsDialogShow } },
        [
          _c("div", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.$t("language.imageSaver.uploadTo")))
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "icon",
            class: (_vm.node && _vm.node.type) + "-small"
          }),
          _vm._v(" "),
          _c("div", { staticClass: "path" }, [
            _vm._v(_vm._s(_vm.node && _vm.newPath))
          ]),
          _vm._v(" "),
          _c("img", {
            staticClass: "edit_path_icon",
            attrs: {
              src: require("../../assets/images/imageSaver/editPath.svg")
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("transferAimsDialog", { ref: "transferAimsDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-707b6a86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-707b6a86","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/image_saver_path.vue
// module id = null
// module chunks = 